import React, { useContext, useState, useEffect } from 'react'
import logo from '../images/LOGO-transparent.png'

import { NavLink } from 'react-router-dom'
import fire from '../auth/fire'
import { Redirect } from 'react-router-dom'
import { AuthContext } from '../auth/auth'
import Loading from '../UiComponents/Loading'
import firebase from 'firebase'
import "react-notifications-component/dist/theme.css";
import { store } from 'react-notifications-component'


const LogIn = () => {
    const [emailError, setEmailError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [loading, setLoading] = useState(false)
    const { currentUser } = useContext(AuthContext);
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    var provider = new firebase.auth.GoogleAuthProvider();

    const notifyPopup = () => {
        store.addNotification({
            title: "Success!",
            message: "You have been Logged in!",
            type: "success",
            background: "pink",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true,
            },
        });
    };
    const handleSubmit = (e) => {
        setLoading(true)
        e.preventDefault();

        fire.auth().signInWithEmailAndPassword(email, password)
            .then(() => {
                notifyPopup()
                setLoading(false)
            }
            ).catch((error) => {
                switch (error.code) {
                    case "auth/user-not-found":
                    case "auth/user-disabled":
                    case "auth/user-not-found":
                        setLoading(false)
                        setEmailError(error.message)
                        break;
                    case "auth/wrong-password":
                        setPasswordError(error.message);
                        setLoading(false)
                        break;
                }
            })
    }

    const loginWithGoogle = (e) => {
        e.preventDefault();
        setLoading(true);
        fire.auth()
            .signInWithPopup(provider).then((result) => {
                var credentials = result.credential
                var token = credentials.accessToken;
                var user = result.user;
                setLoading(false)
                notifyPopup()
                console.log(user);
            }).catch((err) => {
                var errCode = err.code;
                setEmailError(err.email);
                setLoading(false);
            })

    }
    const handleForgotPassword = (e) => {
        e.preventDefault();
        new firebase.auth().sendPasswordResetEmail(
            email)
            .then(function () {
                console.log("Email sent");
            })
            .catch(function (error) {
                // Error occurred. Inspect error.code.
            });
    }

    if (currentUser) {
        return <Redirect to='/' />
    }
    return (
        <>
            <div className="container-fluid d-flex align-items-center mb-5" id="header">
                <div className="container ">
                    <div className="row">
                        <div className="col-10 mx-auto ">
                            <div className="row">
                                <div className="col-lg-6 col-sm-12 col-xs-12 col-md-6">
                                    <div>
                                        <img src={logo} alt="image" className="img-fluid" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12 col-xs-12 col-md-6 ">
                                    <div className="d-flex flex-column align-content-center  ">
                                        <div className="text-center my-3">
                                            <div>
                                                <h1>
                                                    LogIn
                                            </h1>
                                            </div>
                                            <form id="contact-form" className="form m-3 border border-dark p-3 rounded bg-white"
                                            >
                                                <div className="mb-3 text-left">
                                                    <label for="email" className="form-label font-weight-bold">Email address</label>
                                                    <input type="email"
                                                        className="form-control" id="email" aria-describedby="emailHelp" onChange={(e) => { setEmail(e.target.value) }} />
                                                    <div id="emailHelp" className="text-danger">{emailError}</div>
                                                </div>
                                                <div className="mb-3 text-left">
                                                    <label for="password" className="form-label font-weight-bold">Password</label>
                                                    <input type="password" className="form-control" id="password"
                                                        onChange={(e) => { setPassword(e.target.value) }}
                                                    />
                                                    <div id="emailHelp" className="text-danger">{passwordError}</div>
                                                    <div className="text-dark text-right m-2" style={{ cursor: "pointer" }}
                                                        onClick={(e) => { handleForgotPassword(e) }}
                                                    >Forgot Password?</div>
                                                </div>

                                                <div className="container">
                                                    <div className="mx-auto d-flex justify-content-evenly">

                                                        {loading ? <div className="disabled " ><Loading style={"w-25 h-25"} /></div> : <button className="btn bg-primary flex-grow-1 text-white bg-gradient btn-explore" onClick={handleSubmit}>
                                                            Login
                                                    </button>}
                                                        {loading ? <div className="disabled ml-2" ><Loading style={"w-25 h-25"} /></div> : <button className="btn text-black  border border-1 btn-explore ml-2" onClick={loginWithGoogle}>
                                                            Sign In with <img src="https://img.icons8.com/fluent/48/000000/google-logo.png" style={{ width: "26px" }} />
                                                        </button>}
                                                    </div>
                                                    <div className="text-end font-bold mt-2">
                                                        New User?
                                                    <NavLink to='/sign-up' exact >
                                                            <button className="btn border-1 border ml-2" >
                                                                Sign Up
                                                        </button>
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    window.scrollTo(0, 0)
                }
            </div></>

    )
};

export default LogIn;
